import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import AdAffiliatePlacements from "./AdAffiliatePlacements";

export default function AdSlot({ placement, className = "", slotIndex = null, onContentChange }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    api.get(`/api/ads-affiliate/public?placement=${encodeURIComponent(placement)}`)
      .then(({ data }) => {
        if (active) setItems(Array.isArray(data) ? data.filter((item) => item.placement === placement && item.active === true) : []);
      })
      .catch(() => {
        if (active) setItems([]);
      });
    return () => { active = false; };
  }, [placement]);

  const displayedItems = slotIndex === null || items.length < 2
    ? items
    : [items[slotIndex % items.length]];

  return <AdAffiliatePlacements items={displayedItems} className={className} onContentChange={onContentChange} />;
}
